
import PlaceButton from "@/commons/widget/place-button";
import { EavesBoard } from "@/commons/interface/building/eaves-board";
import { Modal, Table, } from "antd";
import classnames from "classnames";
import { useEffect, useState } from "react";
import { ReactComponent as CheckSvg } from '@/commons/icons/table/check.svg';
import { ReactComponent as CheckedSvg } from '@/commons/icons/table/checked.svg';
import TnInput from "@/commons/widget/input/tn-input";
import "./index.less"
import { useParams } from "react-router-dom";
import { addEavesBoard, deleteEavesBoardByIdList, findEavesBoardsByprojectUuid, updateEavesById } from "@/api/building/eaves-board";
import { graphicStore } from "@/commons/store/graphic-store";
import { ARCHI_SUB_CONTROL } from "@/passets/archibase-engine/enums/archi-sub-control";
import TnModal from "@/commons/widget/base-modal";
import TnMessage from "@/commons/widget/message";
import SideBarTool from "@/commons/components/side-bar-tool";
import { SideBarBtnType } from "@/commons/enums/side-bar-btn-type";

export default function EavesBoardPanel() {

    const { projectUuid, modelUuid } = useParams()
    const [loading, setLoading] = useState<boolean>(false); // loading
    const [activeRow, setActiveRow] = useState<EavesBoard>(null); // 表格选中行
    const [hoverRow, setHoverRow] = useState<EavesBoard>(null); // 鼠标悬浮行
    const [eavesBoards, setEavesBoards] = useState<EavesBoard[]>([]); // 檐口板列表
    const [muitiple, setMuitiple] = useState<boolean>(false); // 是否开启多选
    const [selectedRows, setSelectedRows] = useState<EavesBoard[]>([]); // 多选选中的行
    const [editRow, setEditRow] = useState<EavesBoard>(null) // 编辑中的行

    useEffect(() => {
        if (projectUuid) {
            generateData()
        }
    }, [projectUuid])

    // 初始化列表
    const generateData = () => {
        setLoading(true)
        findEavesBoardsByprojectUuid(projectUuid).then(res => {
            let data = res.data || []
            setEavesBoards(data)
        }).catch((e) => {
            TnMessage.error("获取列表失败！")
        }).finally(() => {
            setLoading(false)
        })
    }

    // 点击工具栏添加按钮
    const onAddClick = () => {
        setLoading(true)
        let addData: EavesBoard = {
            thickness: 10,
            height: 100,
            projectUuid: projectUuid
        }
        addEavesBoard(projectUuid, addData).then(res => {
            let id: number = res.data
            addData.id = id
            addData.code = id.toString()
            let newList = [...eavesBoards, addData]
            setEavesBoards([...newList])
            setEditRow(addData)
        }).catch(() => {
            TnMessage.error("添加失败！")
        }).finally(() => {
            setLoading(false)
        })
    }

    // 点击工具栏编辑按钮
    const onEditClick = () => {
        if (!activeRow) {
            TnMessage.warning("未选中檐口板");
            return;
        }
        if (editRow) {
            setEditRow(null)
        } else {
            setEditRow({ ...activeRow })
        }
    }

    // 点击工具栏删除按钮
    const onDeleteClick = () => {
        if ((muitiple && selectedRows?.length === 0) || (!muitiple && !activeRow)) {
            TnMessage.warning("未选中檐口板");
            return;
        }
        TnModal().deleteModal({
            onOk() {
                if (!muitiple) {
                    deleteEavesBoardByIdList([activeRow?.id]).then(res => {
                        if (res.status === 200) {
                            let idx = eavesBoards?.findIndex(item => item.id === activeRow.id);
                            eavesBoards.splice(idx, 1);
                            setEavesBoards([...eavesBoards]);
                            setActiveRow(null);
                            TnMessage.success("删除成功");
                        }
                    }).catch(() => {
                        TnMessage.error("删除失败！")
                    }).finally(() => {
                        Modal.destroyAll();
                    })
                } else {
                    let ids: number[] = selectedRows?.map(item => item.id);
                    deleteEavesBoardByIdList(ids).then(res => {
                        if (res.status === 200) {
                            let newDataBoxs = eavesBoards?.filter(item => !selectedRows?.some(r => r.id === item.id));
                            setEavesBoards(newDataBoxs);
                            setSelectedRows([]);
                            TnMessage.success("删除成功");
                        }
                    }).catch(() => {
                        TnMessage.error("删除失败！")
                    }).finally(() => {
                        Modal.destroyAll();
                    })
                }
            },
            onCancel() {
                Modal.destroyAll();
            },
            closable: true
        })
    }

    // 保存修改
    const onSaveClick = () => {
        setLoading(true)
        updateEavesById(editRow.id, editRow).then(res => {
            let index = eavesBoards.findIndex(item => item.id == editRow.id)
            let newList = [...eavesBoards]
            newList[index] = { ...editRow }
            setEavesBoards([...newList])
            setEditRow(null)
        }).catch(() => {
            TnMessage.error("更新檐口板信息失败！")
        }).finally(() => {
            setLoading(false)
        })
    }

    // 激活二级控制器
    const onAssignClick = (row: EavesBoard) => {
        graphicStore.extraContext.getCurrentViewEditor()?.listeners.signals.onOpeCommandActive.dispatch(ARCHI_SUB_CONTROL.ASSIGNEAVESBOARDCONTROL.name);
        graphicStore.extraContext.getCurrentViewEditor()?.listeners.signals.setInitControlData.dispatch(
            {
                height: row?.height || 0,
                thickness: row?.thickness || 0,
                projectUuid: projectUuid,
                modelUuid: modelUuid
            }
        )
    }

    return (
        <div className="eaves-board-container">
            <SideBarTool onAddBtnClick={onAddClick}
                onConfirmBtnClick={onEditClick}
                onDeleteBtnClick={onDeleteClick}
                activeBtnList={[SideBarBtnType.ADD, SideBarBtnType.DELETE, SideBarBtnType.EDIT,
                SideBarBtnType.SELECT, SideBarBtnType.UN_SELECT
                ]}
                onSelectBtnClick={() => setMuitiple(true)}
                onUnSelectBtnClick={() => setMuitiple(false)}
            />

            <div className="main-content">
                <div className="panel-title">檐口板</div>
                <div className="table-area">
                    <Table
                        rowKey="id"
                        pagination={false}
                        dataSource={eavesBoards}
                        className='tn-monix-table'
                        rowClassName={row => classnames({
                            "monix-row": true,
                            "monix-row-select": activeRow?.id === row.id
                        })}
                        bordered={false}
                        onRow={row => {
                            return {
                                onClick: () => setActiveRow(row),
                                onMouseEnter: () => setHoverRow(row),
                                onMouseLeave: () => setHoverRow(null),
                            }
                        }}
                        sticky
                        loading={loading}
                    >
                        <Table.Column dataIndex="code" title="编号" width='20%' ellipsis
                            render={(value, row: EavesBoard) => {
                                return (
                                    <div className="code">
                                        {editRow?.id == row?.id ? (
                                            <div className="board-input" style={{ marginLeft: "8px" }}>
                                                <TnInput
                                                    size="small"
                                                    onTextChange={(e) => {
                                                        setEditRow({ ...editRow, code: e })
                                                    }}
                                                    value={editRow?.code || ""}
                                                />
                                            </div>
                                        ) : (
                                            <div className='multi-cell'>
                                                <div className="multi-icon" onClick={(e) => {
                                                    e.stopPropagation();
                                                    e.preventDefault();
                                                    let idx = selectedRows?.findIndex(item => item.id === row.id);
                                                    if (idx === -1) {
                                                        setSelectedRows([...selectedRows, row]);
                                                    } else {
                                                        selectedRows.splice(idx, 1);
                                                        setSelectedRows([...selectedRows]);
                                                    }
                                                }}>
                                                    {muitiple && !selectedRows?.some(item => item?.id === row?.id) && <CheckSvg />}
                                                    {muitiple && selectedRows?.some(item => item?.id === row?.id) && <CheckedSvg />}
                                                </div>
                                                <div className="multi-text">{value}</div>
                                            </div>
                                        )}
                                    </div>
                                )
                            }}
                        />
                        <Table.Column dataIndex="thickness" title="厚度" width='25%' ellipsis align="left"
                            render={(value, row: EavesBoard) => {
                                return (
                                    <div className="thickness">
                                        {editRow?.id == row?.id ? (
                                            <div className="board-input">
                                                <TnInput
                                                    size="small"
                                                    value={editRow?.thickness.toString() || ""}
                                                    onTextChange={(e) => {
                                                        setEditRow({ ...editRow, thickness: e })
                                                    }}
                                                />
                                            </div>
                                        ) : (
                                            <div>
                                                {value}
                                            </div>
                                        )}
                                        {"mm"}
                                    </div>
                                )
                            }}
                        />
                        <Table.Column dataIndex="height" title="高度" width='25%' ellipsis align="left"
                            render={(value, row: EavesBoard) => {
                                return (
                                    <div className="height">
                                        {editRow?.id == row?.id ? (
                                            <div className="board-input">
                                                <TnInput
                                                    size="small"
                                                    value={editRow?.height.toString() || ""}
                                                    onTextChange={(e) => {
                                                        setEditRow({ ...editRow, height: e })
                                                    }}
                                                />
                                            </div>
                                        ) : (
                                            <div>{value}</div>
                                        )}
                                        {"mm"}
                                    </div>

                                )
                            }}
                        />
                        <Table.Column title="" width='25%' ellipsis align="left"
                            render={(value, row: EavesBoard) => {
                                if (editRow && editRow?.id == row?.id) {
                                    return (
                                        <div className="save-btn" onClick={() => { onSaveClick() }}>
                                            保存
                                        </div>
                                    )
                                } else if (!!hoverRow && hoverRow?.id === row?.id) {
                                    return (
                                        <PlaceButton onClick={() => { onAssignClick(row) }} />
                                    )
                                } else if (activeRow && activeRow?.id == row.id) {
                                    return (
                                        <PlaceButton onClick={() => { onAssignClick(row) }} />
                                    )
                                } else {
                                    return (
                                        <></>
                                    )
                                }
                            }}
                        />
                    </Table>
                </div>
            </div>
        </div>
    )
}